export const NUMBER_OF_QUESTIONS_PER_LEVEL = 10;
export const DICTIONARY_API_URL =
  'https://api.dictionaryapi.dev/api/v2/entries/en/';
export const users = [
  {
    id: 1,
    name: 'Adele',
    password: 'asimfoot',
    level: null,
  },
];
